<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qpzb9q/cover.jpeg?1684514529107" alt="This image is the cover for the book Beautiful Boss Fall in Love with Me, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beautiful Boss Fall in Love with Me, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p>As a little journalist who is about to graduate from university, due to his outstanding ability, he was often brought along by the beautiful chief editor. After a job, the drunk beauty chief editor came to my bed and the next day, she acted as though nothing had happened.It's just that I can't help but fall in love with her. Facing the beautiful chief editor who only knew her for a few days and my girlfriend who has been sleeping with me for many years, I don't know where to go from here.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yan Dou, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?698c0960